import { db, analytics, logEvent } from './firebase.js';
import { collection, getDocs } from "firebase/firestore";

// Selectors
const postsList = document.getElementById('posts-list');
const sidebarTags = document.getElementById('sidebar-tags');
const filterInput = document.getElementById('filter-input');
const blogContent = document.getElementById('blog-content');
const contentPlaceholder = document.getElementById('content-placeholder');
const contentViewer = document.getElementById('content-viewer');
const contentTitle = document.getElementById('content-title');
const contentMeta = document.getElementById('content-meta');
const contentBody = document.getElementById('content-body');
const contentImage = document.getElementById('content-image');

let allPosts = []; // Cache for posts
let activeTag = null;

// Helpers
function trToSlug(text) {
    if (!text) return '';
    const mapping = {
        'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u',
        'Ç': 'c', 'Ğ': 'g', 'İ': 'i', 'Ö': 'o', 'Ş': 's', 'Ü': 'u'
    };
    let slug = text.toString().toLowerCase().trim();
    for (let char in mapping) {
        slug = slug.replace(new RegExp(char, 'g'), mapping[char]);
    }
    return slug
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-');
}

function getSpotifyEmbedUrl(url) {
    if (!url) return null;
    if (url.includes('spotify.com/embed')) return url;
    return url.replace('spotify.com/', 'spotify.com/embed/');
}

function sortPosts(docs) {
    return docs.sort((a, b) => {
        if (a.isPinned && !b.isPinned) return -1;
        if (!a.isPinned && b.isPinned) return 1;

        const parseDate = (dStr) => {
            if (!dStr) return 0;
            const d = new Date(dStr);
            if (!isNaN(d.getTime())) return d.getTime();
            const parts = dStr.split('/');
            if (parts.length === 3) return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).getTime();
            return 0;
        };
        return parseDate(b.date) - parseDate(a.date);
    });
}

// core Functions
async function fetchPosts() {
    try {
        const querySnapshot = await getDocs(collection(db, "uxai_posts"));
        let docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        allPosts = sortPosts(docs);
        renderTags(allPosts);
        renderBlog(allPosts);
        checkDeepLink();
    } catch (error) {
        console.error("Error fetching posts:", error);
        if (postsList) postsList.innerHTML = '<p style="text-align:center; padding: 1rem;">Yazılar yüklenirken bir hata oluştu.</p>';
    }
}

function renderTags(posts) {
    if (!sidebarTags) return;

    // Extract unique tags
    const tags = new Set();
    posts.forEach(post => {
        if (post.tags && Array.isArray(post.tags)) {
            post.tags.forEach(tag => tags.add(tag));
        }
    });

    const sortedTags = Array.from(tags).sort();

    sidebarTags.innerHTML = `
        <span class="tag-filter ${!activeTag ? 'active' : ''}" onclick="filterByTag(null)">Tümü</span>
        ${sortedTags.filter(tag => tag.toUpperCase() !== 'UX').map(tag => `
            <span class="tag-filter ${activeTag === tag ? 'active' : ''}" onclick="filterByTag('${tag}')">${tag}</span>
        `).join('')}
    `;
}

window.filterByTag = function (tag) {
    activeTag = tag;
    renderTags(allPosts);
    applyFilters();
};

function applyFilters() {
    const term = filterInput ? filterInput.value.toLowerCase() : '';
    const filtered = allPosts.filter(post => {
        const matchesSearch =
            post.title.toLowerCase().includes(term) ||
            (post.category && post.category.toLowerCase().includes(term)) ||
            (post.excerpt && post.excerpt.toLowerCase().includes(term)) ||
            (post.tags && post.tags.some(t => t.toLowerCase().includes(term)));

        const matchesTag = !activeTag || (post.tags && post.tags.includes(activeTag));

        return matchesSearch && matchesTag;
    });
    renderBlog(filtered, false); // Don't re-render tags
}

function renderBlog(posts, shouldRenderTags = true) {
    if (!postsList) return;
    postsList.innerHTML = '';

    if (posts.length === 0) {
        postsList.innerHTML = '<p style="padding: 1rem; color: #888;">Yazı bulunamadı.</p>';
        return;
    }

    if (shouldRenderTags) renderTags(allPosts);

    const palette = ['#F5A202', '#035E7B', '#002E2C', '#776258', '#896279'];

    posts.forEach((post, index) => {
        const item = document.createElement('div');
        item.className = 'post-item';
        item.dataset.id = post.id;
        const assignedColor = palette[index % palette.length];
        item.dataset.color = assignedColor;
        item.style.backgroundColor = assignedColor;

        let tagsHtml = '';
        if (post.tags && post.tags.length > 0) {
            // Filter out tags that are just "UX"
            const filteredTags = post.tags.filter(tag => tag.toUpperCase() !== 'UX');
            if (filteredTags.length > 0) {
                tagsHtml = `
                    <div class="post-tags">
                        ${filteredTags.map(tag => `<span class="tag-badge" style="background: rgba(255,255,255,0.2); color: white;">${tag}</span>`).join('')}
                    </div>
                `;
            }
        }

        item.innerHTML = `
            <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                <span class="post-item-category">${post.category || 'UX&AI'}</span>
                ${post.isPinned ? '<i data-lucide="pin" class="pin-icon" style="color: white;"></i>' : ''}
            </div>
            <div class="post-item-title">${post.title}</div>
            <div class="post-item-date">${post.date || ''}</div>
            ${tagsHtml}
        `;
        item.onclick = () => openPost(post, assignedColor);
        postsList.appendChild(item);
    });
    if (typeof lucide !== 'undefined') lucide.createIcons();
}

function openPost(post, color = null) {
    if (contentPlaceholder) contentPlaceholder.style.display = 'none';
    if (contentViewer) contentViewer.style.display = 'block';

    // Apply color if available
    if (color) {
        document.documentElement.style.setProperty('--post-accent-color', color);
    }

    if (contentTitle) contentTitle.innerText = post.title;
    if (contentMeta) {
        let category = post.category || '';
        let author = post.author || '';

        // Clean "UX", "UX&AI", etc. from metadata for a cleaner look
        const cleanPattern = /\bUX\s*&\s*AI\b|\bUX\b|\bTeam\b/gi;
        category = category.replace(cleanPattern, '').replace(/^[•\s]+|[•\s]+$/g, '').trim();
        author = author.replace(cleanPattern, '').trim();

        const parts = [];
        if (category) parts.push(category);
        if (author) parts.push(author);
        if (post.date) parts.push(post.date);
        contentMeta.innerText = parts.join(' • ');
    }

    // Auto-close sidebar on mobile
    const sidebar = document.querySelector('.blog-sidebar');
    if (sidebar && sidebar.classList.contains('active')) {
        sidebar.classList.remove('active');
        const toggleIcon = document.querySelector('#menu-toggle [data-lucide]');
        if (toggleIcon && typeof lucide !== 'undefined') {
            toggleIcon.setAttribute('data-lucide', 'menu');
            lucide.createIcons();
        }
    }

    if (contentBody) {
        let finalHtml = '';
        if (post.tldr) {
            finalHtml += `
                <div class="tldr-box">
                    <h3>TL;DR</h3>
                    <p>${post.tldr}</p>
                </div>
            `;
        }
        if (post.spotifyUrl) {
            const embedUrl = getSpotifyEmbedUrl(post.spotifyUrl);
            finalHtml += `
                <div class="spotify-player">
                    <iframe style="border-radius:12px" src="${embedUrl}" width="100%" height="152" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                </div>
            `;
        }
        finalHtml += post.content || '<p>İçerik bulunamadı.</p>';
        contentBody.innerHTML = finalHtml;
    }

    if (contentImage) {
        if (post.image && !post.hideImageInArticle && post.image !== '/cover.png' && post.image !== '/uxai_logo.png' && post.image.trim() !== '') {
            contentImage.style.backgroundImage = `url('${post.image}')`;
            contentImage.style.display = 'block';
        } else {
            contentImage.style.display = 'none';
        }
    }

    document.querySelectorAll('.post-item').forEach(el => {
        el.classList.toggle('active', el.dataset.id === post.id);
    });

    if (blogContent) blogContent.scrollTo(0, 0);

    const slug = trToSlug(post.title);
    history.pushState({ postId: post.id }, post.title, `/uxai/${slug}`);
    document.title = `${post.title} - UX&AI Blog`;

    // Log Analytics Event
    if (analytics) {
        logEvent(analytics, 'page_view', {
            page_title: post.title,
            page_location: window.location.href,
            page_path: window.location.pathname + window.location.search
        });
    }
}

function checkDeepLink() {
    const urlParams = new URLSearchParams(window.location.search);
    let slug = urlParams.get('post');
    const palette = ['#F5A202', '#035E7B', '#002E2C', '#776258', '#896279'];

    // If no query param, check path-based slug (e.g., /uxai/slug)
    if (!slug) {
        const path = window.location.pathname;
        if (path.includes('/uxai/')) {
            slug = path.split('/uxai/').pop().replace('.html', '');
        }
    }

    if (slug && allPosts.length > 0) {
        const index = allPosts.findIndex(p => trToSlug(p.title) === slug);
        if (index !== -1) {
            const post = allPosts[index];
            openPost(post, palette[index % palette.length]);
            return;
        }
    }

    // Default: Open the first post if no deep link
    if (allPosts.length > 0) {
        openPost(allPosts[0], palette[0]);
    }
}

// Listeners
if (filterInput) {
    filterInput.oninput = () => applyFilters();
}

window.onpopstate = (event) => {
    if (event.state && event.state.postId) {
        const post = allPosts.find(p => p.id === event.state.postId);
        if (post) openPost(post);
    } else {
        location.reload();
    }
};

// Hamburger Menu Logic
const menuToggle = document.getElementById('menu-toggle');
const sidebar = document.querySelector('.blog-sidebar');

if (menuToggle && sidebar) {
    menuToggle.onclick = () => {
        sidebar.classList.toggle('active');
        const icon = menuToggle.querySelector('[data-lucide]');
        const isActive = sidebar.classList.contains('active');

        if (icon && typeof lucide !== 'undefined') {
            icon.setAttribute('data-lucide', isActive ? 'x' : 'menu');
            lucide.createIcons();
        }
    };
}

// Start
fetchPosts();
